import { BaseNotification } from '@strata/react-notifications';
import { Badge } from '@strata/react-status-icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { WatchingWatchesList } from './WatchingWatchesList';

import { useGetWatchesQuery } from 'store/api/notificationApi';

const Tabs = {
    NOTIFICATIONS: 'notifications',
    WATCHING: 'watching',
};

/**
 * Tab strip + Watching body for the Strata notifications dropdown header slot.
 *
 * Notifications tab: Strata renders its default list / "View All".
 * Watching tab: renders the watches panel here; parent should set Strata's
 * hideNotificationList while this tab is active.
 */
export const NotificationsDropdownTabs = ({
    notifications = [],
    activeTab = Tabs.NOTIFICATIONS,
    onActiveTabChange,
}) => {
    const { data: watches = [], isLoading: isWatchesLoading } = useGetWatchesQuery();

    const newCount = notifications.filter(
        (notification) => notification.status === BaseNotification.Statuses.NEW,
    ).length;
    const isWatching = activeTab === Tabs.WATCHING;

    const handleNotificationsTabClick = () => {
        onActiveTabChange(Tabs.NOTIFICATIONS);
    };

    const handleWatchingTabClick = () => {
        onActiveTabChange(Tabs.WATCHING);
    };

    return (
        <div className="sds_notifications-dropdown-tabs" role="tablist">
            <div className="sds_notifications-dropdown-tabs__tabs">
                <button
                    type="button"
                    role="tab"
                    aria-selected={activeTab === Tabs.NOTIFICATIONS}
                    className={classNames('sds_notifications-dropdown-tabs__tab', {
                        'sds_notifications-dropdown-tabs__tab--active':
                            activeTab === Tabs.NOTIFICATIONS,
                    })}
                    onClick={handleNotificationsTabClick}
                >
                    Notifications
                    <Badge intent={Badge.Intent.UNREAD} count={newCount} />
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={isWatching}
                    className={classNames('sds_notifications-dropdown-tabs__tab', {
                        'sds_notifications-dropdown-tabs__tab--active': isWatching,
                    })}
                    onClick={handleWatchingTabClick}
                >
                    Watching
                    <Badge intent={Badge.Intent.COUNT} count={watches.length} />
                </button>
            </div>
            {isWatching ? (
                <WatchingWatchesList watches={watches} isLoading={isWatchesLoading} />
            ) : null}
        </div>
    );
};

NotificationsDropdownTabs.Tabs = Tabs;

NotificationsDropdownTabs.propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.shape({})),
    activeTab: PropTypes.oneOf([Tabs.NOTIFICATIONS, Tabs.WATCHING]),
    onActiveTabChange: PropTypes.func.isRequired,
};
